import { objectKeys } from '@motimate/utils';
import type { UserLanguage } from '@motimate/utils/types/user';
import { languages } from '@ui/utils/language';
import { wrapClassNames } from '@ui/utils/tailwind';
import type { FC } from 'react';
import { Combobox } from '.';

const allLanguagesForSelect = objectKeys(languages)
  .map(lang => ({
    label: languages[lang].name,
    value: lang,
  }))
  .sort((a, b) => (a.label > b.label ? 1 : -1));

export const LanguageSelect: FC<{
  containerClassName?: string;
  onChange: (value: UserLanguage) => void;
  options?: UserLanguage[];
  exclude?: UserLanguage[];
  value?: UserLanguage | null | undefined;
  translations?: Record<UserLanguage, string>;
  placeholder?: string;
}> = ({ containerClassName, onChange, options, value, exclude, translations, placeholder }) => {
  const getOptions = () => {
    if (options)
      return options.map(option => ({ label: translations?.[option] ?? languages[option].name, value: option }));

    const translatedLangs = allLanguagesForSelect.map(lang => ({
      label: translations?.[lang.value] ?? lang.label,
      value: lang.value,
    }));
    if (exclude) return translatedLangs.filter(lang => !exclude.includes(lang.value));

    return translatedLangs;
  };
  return (
    <div className={wrapClassNames(`w-44 ${containerClassName}`)}>
      <Combobox
        placeholder={placeholder}
        value={value || undefined}
        setValue={v => {
          if (!v) return;
          onChange(v as UserLanguage);
        }}
        enableSearch={options && options.length > 5}
        options={getOptions()}
        popoverContentClassName={'w-(--radix-popover-trigger-width)'}
      />
    </div>
  );
};
